(function(module) {
try {
  module = angular.module('betosyswebapp');
} catch (e) {
  module = angular.module('betosyswebapp', []);
}
module.run(['$templateCache', function($templateCache) {
  $templateCache.put('components/common/directives/toastErrorTemplate.tpl.html',
    '<md-toast style="z-index:2147483000; height:100px; margin-top:60px;"><i ng-if="errorAlert.type === \'warning\'" class="glyphicon glyphicon-warning-sign" style="font-size:30px;color:yellow;"></i> <i ng-if="errorAlert.type === \'info\'" class="glyphicon glyphicon-info-sign" style="font-size:30px;color:white;"></i> <i ng-if="errorAlert.type === \'danger\'" class="glyphicon glyphicon-alert" style="font-size:30px;color:red;"></i> <i ng-if="errorAlert.type === \'success\'" class="glyphicon glyphicon-ok" style="font-size:30px;color:green;"></i> <span style="margin-left:20px;" class="md-toast-text" ng-bind="errorAlert.message" flex=""></span><md-button ng-click="closeToast()" translate="responseErrorDilaog.ok" aria-label="Ok"></md-button></md-toast>');
}]);
})();



// WEBPACK FOOTER //
// ./.tmp/components/common/directives/toastErrorTemplate.tpl.js